export const AUTH_ERROR = "AUTH_ERROR"
